/**
 * Rutas de Geofence, sin componentes ni red.
 *
 * Vive aparte de `secciones.js` porque `App.js` la importa de forma directa
 * para declarar las rutas, y lo que importa `App.js` lo cargan también sus
 * pruebas. `secciones.js` trae el cliente HTTP; aquí solo hay datos.
 */

/** Las cinco secciones, en el orden del menú. */
export const CLAVES_DE_SECCION = ["en-vivo", "historial", "horas", "analisis", "configuracion"];

export const rutaDeSeccion = clave => `/geofence/${clave}`;

/**
 * A dónde fue a dar cada una de las doce rutas anteriores.
 *
 * Se conservan como redirecciones: hay enlaces guardados en favoritos y en
 * mensajes, y deben seguir abriendo la misma vista. Las secciones de una sola
 * vista no llevan `tab`: no muestran pestañas.
 */
export const RUTAS_ANTERIORES = {
	"/geofence/live": { seccion: "en-vivo", tab: "mapa" },
	"/geofence/health": { seccion: "en-vivo", tab: "dispositivos" },
	"/geofence/visits": { seccion: "historial", tab: "visitas" },
	"/geofence/routes": { seccion: "historial", tab: "recorrido" },
	"/geofence/events": { seccion: "historial", tab: "eventos" },
	"/geofence/hours": { seccion: "horas", tab: "semana" },
	"/geofence/cumplimiento": { seccion: "horas", tab: "registro" },
	"/geofence/claims": { seccion: "horas", tab: "por-aprobar" },
	"/geofence/insights": { seccion: "analisis" },
	"/geofence/zones": { seccion: "configuracion", tab: "zonas" },
	"/geofence/assignments": { seccion: "configuracion", tab: "asignaciones" },
	"/geofence/settings": { seccion: "configuracion", tab: "reglas" },
};

/**
 * La URL nueva para una ruta vieja, conservando lo que traía la original.
 *
 * Ninguna vista usa parámetros hoy, pero un enlace con `?userId=` o un `#`
 * no debe perderlos por el solo hecho de pasar por la redirección.
 */
export const destinoDeRutaAnterior = (rutaVieja, search = "", hash = "") => {
	const destino = RUTAS_ANTERIORES[rutaVieja];
	if (!destino) return null;
	const params = new URLSearchParams(search);
	if (destino.tab) params.set("tab", destino.tab);
	const consulta = params.toString();
	return `${rutaDeSeccion(destino.seccion)}${consulta ? `?${consulta}` : ""}${hash}`;
};
